import * as api from '../../services/withdram'
import lodash from 'lodash'

export const FETCH_WITHDRAMS = 'FETCH_WITHDRAMS';
export const FETCH_WITHDRAM = 'FETCH_WITHDRAM';


export const fetchWithdraw = (id) => ({
    type: FETCH_WITHDRAM,
    payload: {
        promise: api.findWithdraw({id: id})
    }
});


export const fetchWithdraws = (params, pagination, sort, extra) => {

    return {
        type: FETCH_WITHDRAMS,
        payload: {
            promise: api.findWithdraws(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'userId'),
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/withdram.js